/**
 * E-SOLO Meta Pixel — browser-only tracking (direct fbq).
 * Pixel ID: 1256688348469873
 *
 * Events:
 *   book_appointment_page_view → ViewContent
 *   appointment_form_submit    → Lead (+ Advanced Matching em/ph/fn/ln)
 *   contact_form_submit        → Lead (+ Advanced Matching when available)
 *   phone_click                → Contact
 *   email_click                → Contact
 *   location_click             → FindLocation
 *   parking_click              → ParkingInterest (trackCustom)
 */
(function () {
  const PIXEL_ID = '1256688348469873';
  const PANDECTES_CONSENT_EVENT = 'Pandectes_Consent_Update';
  const PANDECTES_TARGETING_CATEGORY = 'C0003';

  let pixelBootstrapped = false;
  const pendingEvents = [];

  const LOCATION_HREF_PATTERNS = [
    'google.com/maps',
    'maps.google.com',
    'goo.gl/maps',
    'maps.app.goo.gl',
    'g.page',
  ];

  function isPandectesActive() {
    return Boolean(window.pandectesRulesSettings || window.pandectesBannerSettings);
  }

  function getPandectesTargetingAllowed() {
    const dataLayer = window.dataLayer || [];

    for (let i = dataLayer.length - 1; i >= 0; i--) {
      const entry = dataLayer[i];

      if (!entry || entry.event !== PANDECTES_CONSENT_EVENT) {
        continue;
      }

      const status = entry.pandectes_status;

      if (status === 'allow') {
        return true;
      }

      if (status === 'deny' || status === 'revoke') {
        return false;
      }

      const categories = entry.pandectes_categories || {};

      if (categories[PANDECTES_TARGETING_CATEGORY] === 'allow') {
        return true;
      }

      if (categories[PANDECTES_TARGETING_CATEGORY] === 'deny') {
        return false;
      }

      return false;
    }

    return null;
  }

  function canTrackMarketing() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        if (window.Shopify.customerPrivacy.userCanBeTracked()) {
          return true;
        }

        const trackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        if (trackingConsent === 'yes') {
          return true;
        }

        if (trackingConsent === 'no') {
          return false;
        }
      }
    } catch (error) {
      // Shopify Consent API unavailable
    }

    const pandectesTargeting = getPandectesTargetingAllowed();

    if (pandectesTargeting === true) {
      return true;
    }

    if (pandectesTargeting === false) {
      return false;
    }

    if (!isPandectesActive()) {
      return true;
    }

    return false;
  }

  function bootstrapPixel() {
    if (typeof window.fbq !== 'function') {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) {
          return;
        }

        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };

        if (!f._fbq) {
          f._fbq = n;
        }

        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }

    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }

  function flushPendingEvents() {
    while (pendingEvents.length > 0) {
      const item = pendingEvents.shift();
      dispatchEsoloEvent(item.name, item.data);
    }
  }

  function initPixelWhenAllowed() {
    if (pixelBootstrapped) {
      return;
    }

    if (!canTrackMarketing()) {
      return;
    }

    bootstrapPixel();
    pixelBootstrapped = true;
    flushPendingEvents();
  }

  function watchPandectesConsent() {
    window.dataLayer = window.dataLayer || [];
    const originalPush = window.dataLayer.push;

    window.dataLayer.push = function () {
      const result = originalPush.apply(this, arguments);

      for (let i = 0; i < arguments.length; i++) {
        const entry = arguments[i];

        if (entry && entry.event === PANDECTES_CONSENT_EVENT) {
          initPixelWhenAllowed();
        }
      }

      return result;
    };

    window.dataLayer.forEach(function (entry) {
      if (entry && entry.event === PANDECTES_CONSENT_EVENT) {
        initPixelWhenAllowed();
      }
    });
  }

  function bindConsentListeners() {
    document.addEventListener('trackingConsentAccepted', initPixelWhenAllowed);
    watchPandectesConsent();

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        function () {
          initPixelWhenAllowed();
        }
      );
      return;
    }

    initPixelWhenAllowed();
  }

  function normalizeEmail(email) {
    if (!email || typeof email !== 'string') {
      return '';
    }

    return email.trim().toLowerCase();
  }

  function normalizePhone(phone) {
    if (!phone || typeof phone !== 'string') {
      return '';
    }

    const trimmed = phone.trim();
    const hasPlus = trimmed.charAt(0) === '+';
    const digits = trimmed.replace(/\D/g, '');

    if (!digits) {
      return '';
    }

    return hasPlus ? '+' + digits : digits;
  }

  function splitName(fullName) {
    if (!fullName || typeof fullName !== 'string') {
      return { fn: '', ln: '' };
    }

    const parts = fullName.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) {
      return { fn: '', ln: '' };
    }

    if (parts.length === 1) {
      return { fn: parts[0], ln: '' };
    }

    return {
      fn: parts[0],
      ln: parts.slice(1).join(' '),
    };
  }

  function buildAdvancedMatching(data) {
    const matching = {};
    const email = normalizeEmail(data.email || data.em);
    const phone = normalizePhone(data.phone || data.ph);
    const names = splitName(data.name || '');
    const fn = (data.fn || names.fn || '').trim().toLowerCase();
    const ln = (data.ln || names.ln || '').trim().toLowerCase();

    if (email) {
      matching.em = email;
    }

    if (phone) {
      matching.ph = phone;
    }

    if (fn) {
      matching.fn = fn;
    }

    if (ln) {
      matching.ln = ln;
    }

    return matching;
  }

  function trackBrowser(eventName, customData, options) {
    if (typeof window.fbq !== 'function') {
      return;
    }

    const opts = options || {};

    if (opts.custom) {
      window.fbq('trackCustom', eventName, customData || {});
      return;
    }

    window.fbq('track', eventName, customData || {});
  }

  /**
   * Maps theme event names to Meta Pixel events.
   * @param {string} name
   * @param {object} [data]
   */
  function dispatchEsoloEvent(name, data) {
    const payload = data || {};
    const matching = buildAdvancedMatching(payload);

    switch (name) {
      case 'book_appointment_page_view':
        trackBrowser('ViewContent', {
          content_name: 'Book an Appointment',
          content_category: 'appointment',
          content_ids: [payload.page_handle || 'book-an-appointment'],
        });
        break;

      case 'appointment_form_submit':
        if (Object.keys(matching).length > 0) {
          window.fbq('init', PIXEL_ID, matching);
        }

        trackBrowser('Lead', {
          content_name: 'Appointment Form',
          content_category: 'appointment',
          suit_type: payload.suit_type || '',
          people_count: payload.people_count || '',
          booking_date: payload.booking_date || '',
        });
        break;

      case 'contact_form_submit':
        if (Object.keys(matching).length > 0) {
          window.fbq('init', PIXEL_ID, matching);
        }

        trackBrowser('Lead', {
          content_name: 'Contact Form',
          content_category: 'contact',
        });
        break;

      case 'phone_click':
        trackBrowser('Contact', {
          content_category: 'phone',
          content_name: payload.phone || '',
          link_text: payload.link_text || '',
        });
        break;

      case 'email_click':
        trackBrowser('Contact', {
          content_category: 'email',
          content_name: payload.email || '',
          link_text: payload.link_text || '',
        });
        break;

      case 'location_click':
        trackBrowser('FindLocation', {
          content_name: payload.link_text || 'Directions',
          content_category: payload.location_type || 'maps',
          link_url: payload.link_url || '',
        });
        break;

      case 'parking_click':
        trackBrowser('ParkingInterest', {
          content_name: payload.link_text || 'Parking',
          content_category: 'parking',
          link_url: payload.link_url || '',
        }, { custom: true });
        break;

      default:
        break;
    }
  }

  function trackEsoloEvent(name, data) {
    if (!pixelBootstrapped) {
      if (canTrackMarketing()) {
        initPixelWhenAllowed();
      } else {
        pendingEvents.push({ name: name, data: data || {} });
        return;
      }
    }

    if (!pixelBootstrapped) {
      pendingEvents.push({ name: name, data: data || {} });
      return;
    }

    dispatchEsoloEvent(name, data);
  }

  function isLocationLink(href) {
    if (!href) {
      return false;
    }

    return LOCATION_HREF_PATTERNS.some(function (pattern) {
      return href.indexOf(pattern) !== -1;
    });
  }

  function initClickTracking() {
    document.addEventListener('click', function (event) {
      const parkingLink = event.target.closest('[data-esolo-track="parking"]');

      if (parkingLink) {
        trackEsoloEvent('parking_click', {
          link_url: parkingLink.getAttribute('href') || '',
          link_text: (parkingLink.textContent || '').trim(),
          location_type: 'parking',
        });
        return;
      }

      const telLink = event.target.closest('a[href^="tel:"]');

      if (telLink) {
        trackEsoloEvent('phone_click', {
          phone: telLink.getAttribute('href').replace('tel:', ''),
          link_text: (telLink.textContent || '').trim(),
        });
        return;
      }

      const mailtoLink = event.target.closest('a[href^="mailto:"]');

      if (mailtoLink) {
        trackEsoloEvent('email_click', {
          email: mailtoLink.getAttribute('href').replace('mailto:', '').split('?')[0],
          link_text: (mailtoLink.textContent || '').trim(),
        });
        return;
      }

      const locationLink = event.target.closest('a[href]');

      if (locationLink && isLocationLink(locationLink.getAttribute('href'))) {
        trackEsoloEvent('location_click', {
          link_url: locationLink.getAttribute('href'),
          link_text: (locationLink.textContent || '').trim(),
          location_type: 'maps',
        });
      }
    });
  }

  bindConsentListeners();

  window.publishEsoloEvent = trackEsoloEvent;
  window.trackEsoloEvent = trackEsoloEvent;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickTracking);
  } else {
    initClickTracking();
  }
})();
